export default "__VITE_ASSET__fEy_Xb4S__"